var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-promos-like btn btn-icon",class:{ 'is-active': _vm.isFavorite },attrs:{"data-like":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click', _vm.isFavorite)}}},[_c('a-icon',{attrs:{"icon":"Heart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }